import React from 'react';
import './App.css';
import CircularFoodSystems from './pages/CircularFoodSystems/CircularFoodSystems';

function App() {
	return (
		<div className='App'>
			<CircularFoodSystems />
		</div>
	);
}

export default App;
